

export interface IPlanification {
  count: number;
  next: string | null;
  previous: string | null;
  numero_paginas: number;
  data: IDataPlanificacion[]
}

export interface IDataPlanificacion {
  id_planificador: number;
  time_map: string;
  fecha_inicio: string;
  fecha_fin: string;
  flota: string;
}

export interface IDataPlanificacionParams extends Partial<IDataPlanificacion> {
  fecha_final_after?: string;
  page_size?: number;
  page?: number;
}


/* export interface IHorasDisponibles {
  hora: number;
  hora_formato: string;
  estado: boolean;
  id_user: number | null;
  id_preventa: null | number;
  fecha_hora_limite: null | string;
} */

/* export interface JsonDataFlotaCalendario {
  fecha: string;
  horas: IHorasDisponibles[];
} */



export interface IPlanificationBlock {
  fecha: string;
  flota: string;
  horas: number[];
  id_preventa: string;
  tiempo: string; //hh:mm
  motivo: string;
  forzar?: boolean
}

export interface IPlanificationUnblock {
  fecha: string;
  flota: string;
  horas: number[];
}

export interface IAuxPlanificion {
  fecha_inicial: string,
  fecha_final: string,
  id_planificador: number | null
}

export interface ICalendarioProps {
  horasSelect: number[];
  valor_hora: number;
  hora_limite?: string | null;
  id_user?: number | undefined;
  codigo_flota: string;
  id_hora: string;
  fecha_selecionada: string;
  id_preventa: string;
  numero_tecnico: number
}

export enum TiempoBloqueoENUM {
  COUNTDOWNINTERVAL = 600,
  COUNTDOWNTIMEOUT = 600000,

  COUNTDOWNINTERVAL_PYL = 60,
  COUNTDOWNTIMEOUT_PYL = 60000
}